module.exports = __webpack_public_path__ + "img/3b672cc48093f8b7279811e6bc0139a8.png";